import React, { Component } from 'react';
import TopNav from '../components/TopNav';
import {pageReload} from '../util/PageReload';
import Axios from 'axios';
import { Redirect } from 'react-router-dom';
import ConfirmModal from './modal/ConfirmModal';
import { PulseLoader } from 'halogenium';

export class CustomerProfile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            history: [],
            pending_orders: [],
            customer: this.props.app.state.customer,
            isCheckingPayment: {},
        }

        // Race condition source of truth for this.state.isCheckingPayment
        this.isCheckingPayment = {}
        this.confirmModalRef = React.createRef()
    }

    componentDidMount() {
        this.props.app.loadCustomer();
        this.loadTransactionHistory();
        this.loadPendingOrders();
        this.requestNotificationPermission();

        // Only works on Android phones
        $(document).off('message.push_message').on('message.push_message', this.loadPendingOrders)
    }

    requestNotificationPermission = () => {
        if ('Notification' in window && firebase.messaging.isSupported()) {
            const getToken = () => {
                const messaging = firebase.messaging();
                messaging
                    .requestPermission()
                    .then(() => {
                        // get the token in the form of promise
                        return messaging.getToken()
                    })
                    .then((token) => {
                        this.sendTokenToServer(token)
                    })
                    .catch(function (err) {
                        console.log("Unable to get permission to notify.", err);
                    });

                this.monitorRefreshToken()
            }

            if (Notification.permission === "granted") {
                getToken()
            }
            else if (Notification.permission === "default") {
                if (confirm("Allow Orderlah to send push notification to you when order is ready?")) {
                    getToken()
                }
            }
        }
    }

    sendTokenToServer = (token) => {
        Axios.post(`/customer/update_fcm_token`, {
            fcm_token: token,
        }).then((res) => {
            
        })
        .catch((error) => {
            console.log(error)
        }).finally(() => {
            
        })
    }

    monitorRefreshToken = () => {
        // Callback fired if Instance ID token is updated.
        messaging.onTokenRefresh(() => {
            messaging.getToken().then((refreshedToken) => {
                console.log('Token refreshed.');
                // Send Instance ID token to app server.
                this.sendTokenToServer(refreshedToken);
                
            }).catch((err) => {
                console.log('Unable to retrieve refreshed token ', err);
            });
        });
    }

    componentWillUnmount() {
        
    }

    loadCustomer = () => {
        Axios.get(`/customer/find?id=${this.props.app.state.customer.id}`)
        .then((res) => {
            this.setState({
                customer: res.data
            })
        }).catch((error) => {
            console.log(error)
        })
    }

    loadTransactionHistory = () => {
        Axios.get(`/customer/transactions?firebase_uid=${this.props.app.state.customer.firebase_uid}`)
        .then((res) => {
            this.setState({
                history: res.data
            })
        }).catch((error) => {
            console.log(error)
        })
    }
    loadPendingOrders = (tableSessionId) => {
        let url = `/customer/pending_orders`
        if (tableSessionId) {
            url += `?table_session_id=${tableSessionId}`
        }
        Axios.get(url)
        .then((res) => {
            if (tableSessionId) {
                // Handle single order
                let tableSessionData = res.data
                let pending_orders = this.state.pending_orders
                if (pending_orders && Array.isArray(pending_orders) && tableSessionData && Array.isArray(tableSessionData)) {
                
                    tableSessionData.forEach(tsData => {
                        let index = pending_orders.findIndex(ts => ts.id == tsData.id)
                        if (index > -1) {
                            pending_orders[index] = tsData      
                        }
                    })
                    this.setState({
                        pending_orders: [...pending_orders]
                    })
                }
            }
            else {
                // All orders
                this.setState({
                    pending_orders: res.data
                })
            }
        }).catch((error) => {
            console.log(error)
        })
    }

    getPendingOrderBody = () => {
        let totalPrice = 0
        let trs = []
        if (this.state.pending_orders == null || this.state.pending_orders.length == 0) {
            trs = <tr>
                <td style={{textAlign:"center"}} colSpan="4">{lang.no_pending_orders}</td>
            </tr>
        }
        else {
            trs = this.state.pending_orders.map(row => {
                let orders = (row.orders || [])
                let isPending = orders.length > 0 && orders.find(order => order.quantity > order.quantity_served)

                let isPaid = true
                if (row.bills.length == 0) {
                    // Has table session and orders, but no bill
                    // If payment is made, we will have a bill associated with this
                    // table session
                    isPaid = false
                }
                let statusText = "Pending"
                if (!isPaid) {
                    let isOrderSessionSameAsCurrentSession = this.props.app.state.current_session && row.id == this.props.app.state.current_session.id
                    statusText = <>
                        <div className="mb-1">Waiting payment</div>
                        <div>
                            {
                                isOrderSessionSameAsCurrentSession &&
                                <button className="btn btn-primary btn-sm mr-2" onClick={() => {
                                    if (this.props.app.state.current_session.is_pickup_confirmed) {
                                        this.props.history.push(`/payment/${this.props.match.params.tableQR}`)
                                    }
                                    else {
                                        this.props.history.push(`/pickup/${this.props.match.params.tableQR}`)
                                    }
                                }}>{lang.pay_now}</button>
                            }
                            
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <button className="btn btn-danger btn-sm" onClick={() => this.onCancelOrder(row.id)}>{lang.cancel_order}</button>
                                {
                                    this.state.isCheckingPayment[row.id] ?
                                    <PulseLoader className="" color="#ffa733" size="10px" margin="4px" /> :
                                    <button className="btn btn-primary ml-1" onClick={() => this.onCheckPaymentClicked(row.id)}>{lang.check_payment}</button>
                                }
                            </div>
                        </div>
                    </>
                }
                else {
                    statusText = isPending ? 
                    "Pending" : 
                    <span className="text-success">Ready</span>
                }
                totalPrice += row.total ? parseFloat(row.total) : 0

                return <tr key={row.id}>
                    <td>{moment(row.updated_at).format('Do MMM YYYY, h:mm a')}</td>
                    <td>{row.name}</td>
                    <td style={{textAlign:"center"}} onClick={() => this.showReceipt(row)}>
                        {
                            row.queue_number ?
                            <a href="#/">{row.queue_number}</a> :
                            <>
                                Ref No: <a href="#/">{row.id}</a>
                            </>
                        }
                    </td>
                    <td style={{textAlign:"center"}}>{statusText}</td>
                </tr>
            })
        }
        return trs
    }
    showReceipt = (row) => {
        window.open(`/customer/${window.customerId}/receipt/${row.id}`)
    }

    onCheckPaymentClicked= (tableSessionId) => {
        this.isCheckingPayment[tableSessionId] = true

        this.setState({
            isCheckingPayment: {...this.isCheckingPayment},
        })

        $.ajax({
            url     : `/table_sessions/${tableSessionId}/user_check_payment_status`,
            type    : 'post',
            data    : {
                t: moment().format("YYYY-MM-DD HH:mm:ss")
            },
            success: () => {
                this.loadPendingOrders(tableSessionId)
            }
        })
        .always(() => {
            delete(this.isCheckingPayment[tableSessionId])
            this.setState({
                isCheckingPayment: {...this.isCheckingPayment},
            })
        })
    }
    onCancelOrder = (tableSessionId) => {
        let message = (lang.confirm_cancel_order || "Sure to cancel this order?").replace("<br>", "\n");
        this.setState({
            confirmModal: <ConfirmModal 
                isYesDestructive={true}
                yesText={lang.cancel_order || "Cancel Order"}
                ref={this.confirmModalRef}
                pickup={this.props.app.state.table.pickup}
                table_session_id={table_session_id}
                message={message}
                cancelOrderProp={true}
                onClose={() => {
                    this.setState({
                        confirmModal: null
                    })
                }}
                onYes={() => {
                    this.cancelOrder(this.confirmModalRef.current, tableSessionId)
                }}
                onNo={() => {
                    this.setState({
                        confirmModal: null
                    })
                }}
            />
        })
    }

    cancelOrder = (confirmDialog, tableSessionId) => {
        confirmDialog.isLoading(true)
        Axios.post(`/customer/table_sessions/${tableSessionId}/cancel_order`)
        .then((res) => {
            console.log(res)
            pageReload.reload()
        }).catch((error) => {
            alert(error.message)
        }).finally(() => {
            confirmDialog.close()
        })
    }
    
    getBody() {
        let totalPrice = 0
        let trs = this.state.history.map(row => {
            totalPrice += row.total ? parseFloat(row.total) : 0
            return <tr key={row.id}>
                <td>{moment(row.created_at).format('Do MMM YYYY, h:mm a')}</td>
                <td>{row.name}</td>
                <td className="currency_td">
                    <span className="currency_label">{this.props.app.state.currencyName}</span><span className="currency_value">{parseFloat(row.total).toFixed(2)}</span>
                </td>
            </tr>
        })
        trs.push(
            <tr key="999999">
                <td colSpan="2" style={{textAlign:"center"}}><strong>{lang.total}</strong></td>
                <td className="currency_td">
                    <strong>
                        <span className="currency_label">{this.props.app.state.currencyName}</span><span className="currency_value">{totalPrice.toFixed(2)}</span>
                    </strong>
                </td>
            </tr>
        )
        return trs
    }

    logout() {
        Axios.post('/customer/logout')
            .then((res) => {
                this.props.app.logoutFirebase()
                this.props.history.goBack()
            })
    }

    render() {
        if (!customerId) {
            return <Redirect to={`/category/${this.props.match.params.tableQR}`} />
        }
        return (
            <div>
                <TopNav
                    tableQR={this.props.match.params.tableQR}
                    title={lang.order}
                    table={this.props.app.state.table}
                    backButton={true}
                    backLabel={lang.back} back={`/category/${this.props.match.params.tableQR}`}
                />
                {this.state.confirmModal}
                <div className='col-sm-12'>
                    <div style={{ padding: '50px 10px 10px 10px', marginBottom: "20px", backgroundColor: "white" }}>
                        <h3>{lang.my_profile}</h3>
                        <h4>{this.props.app.state.customer.name}</h4>
                        <h4>{this.props.app.state.customer.phone_number}</h4>
                    </div>
                    {/* <div style={{ padding: '10px', marginBottom: "20px", backgroundColor: "white" }}>
                        <div id='firebaseui-login-container'></div>
                    </div> */}

                    <h4>{lang.pending_orders}</h4>
                    <table className="table table-bordered" style={{marginTop: '20px', backgroundColor: "white"}}>
                        <thead>
                            <tr>
                                <th>{lang.purchase_date}</th>
                                <th>{lang.merchant}</th>
                                <th style={{textAlign:"center"}}>{lang.order_number}</th>
                                <th style={{textAlign:"center"}}>{lang.status}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getPendingOrderBody()}
                        </tbody>
                    </table>

                    <h4>{lang.transaction_history}</h4>
                    <table className="table table-bordered" style={{marginTop: '20px', backgroundColor: "white"}}>
                        <thead>
                            <tr>
                                <th>{lang.purchase_date}</th>
                                <th>{lang.merchant}</th>
                                <th>{lang.total_spent}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getBody()}
                        </tbody>
                    </table>
                    <button className="btn btn-danger" style={{marginBottom: "80px"}} onClick={() => this.logout()}>{lang.logout}</button>
                </div>
            </div>
        )
    }
}